import { api } from '../utils/request';

/**
 * Booking API - User Portal
 * Handles fetching user bookings
 */

// Get all user bookings
export const myBookings = async () => {
    const resp = await api({
        endpoint: '/user/bookings',
        method: 'GET',
    });
    return resp;
};
